//------------------------------------------------------------------------------
// name: meta.config.ts
// author: mudas
// created: 2026/03/20 17:41:39
//------------------------------------------------------------------------------

import { MetaItem } from 'common/hooks';

export const metaConfig: MetaItem[] = [
  {
    name: 'description',
    content:
      '绘梦天工平台 是网易伏羲自主研发的游戏创作生态平台，致力于搭建高效的创作服务链接通道。 平台通过人工智能推荐算法，精准连接创作者技能与需求方：为游戏项目、游戏玩家等提供灵活定制的创作解决方案；同时为海内外创作者，开辟可持续的创作变现路径。',
  },
  {
    name: 'keywords',
    content:
      '绘梦天工,huimengtiangong,天工,tiangong,美术外包,原画外包,美术外包平台,原画设计,平面设计,美术服务,角色建模,场景建模,角色原画,美宣设计,插画设计,插画外包,游戏美术外包,游戏原画',
  },
];
